import VuexPersistence from 'vuex-persist';
import {
  STORAGE_VUEX_LIBRARY_PREF_KEY,
  STORAGE_VUEX_LIBRARY_PREF_VERSION,
} from '@motionelements/core/src/app.constants.js';

export default new VuexPersistence({
  key: STORAGE_VUEX_LIBRARY_PREF_KEY,
  storage: window.localStorage,
  reducer: ({ library }) => ({
    // hash: `${user.jwt.id}|${STORAGE_VUEX_LIBRARY_PREF_VERSION}`,
    hash: `${STORAGE_VUEX_LIBRARY_PREF_VERSION}`,
    library: {
      preferences: library.preferences,
    },
    modifiedAt: Math.round(Date.now() / 1000),
  }),
  filter: (mutation) => [
    'library/setPreferences',
  ].includes(mutation.type),
});
